/**
 * Converts a restaurant name to a URL-friendly slug
 * Handles edge cases: empty strings, special characters, accented characters
 */
export function generateRestaurantSlug(name: string): string {
  if (!name || name.trim().length === 0) {
    throw new Error('Restaurant name cannot be empty');
  }

  const slug = name
    .toLowerCase()
    .normalize('NFD') // Decompose accented characters
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics (é → e)
    .replace(/['']/g, '') // Remove apostrophes
    .replace(/[&]/g, 'and') // Replace & with 'and'
    .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric with hyphens
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens

  if (slug.length === 0) {
    throw new Error(`Cannot generate valid slug from name: "${name}"`);
  }

  return slug;
}
